import { all, call, put, takeEvery } from "@redux-saga/core/effects";
import { AnyAction } from "redux";
import { select } from "redux-saga/effects";
import { RootState } from "../../../core/store";
import { setLoading } from "../../layouts/main-layout/MainLayout.reducer";
import {
  DELETEVIEWINSPECTIONSTEMPLATE,
  GETVIEWINSPECTIONSLIST,
} from "./ViewInspectionPage.action";
import {
  deleteInspectonsByTemplateIdAPi,
  getInspectonsByTemplateIdAPi,
} from "./ViewInspectionPage.api";
import {
  DeleteTemplateParameterType,
  DeleteTemplateSetParameterType,
  ViewInspectionPageParameterType,
  ViewInspectionPageState,
} from "./ViewInspectionPage.type";
import {
  setViewInspectionInitState,
  setDeletedSuuccessfully,
} from "./ViewInspectionPage.reducer";
import { ActionResponseType } from "../../../common/types/common.types";
import { openPopup } from "../../../components/Popups/Popup.reducer";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import { InspectionSetListTypeDTO } from "../../../common/types/common.dto.types";

const fetchViewInspectionsSaga = function* (): any {
  yield takeEvery(GETVIEWINSPECTIONSLIST, function* (action: AnyAction): any {
    yield put(setLoading(true));

    // state
    const state: ViewInspectionPageParameterType = yield select(
      (s: RootState) => s.viewInspectionPageReducer
    );

    const parameters: ViewInspectionPageParameterType = action.payload;
    const result: ViewInspectionPageState = yield call(() =>
      getInspectonsByTemplateIdAPi(parameters)
    );
    if (result != null && result.Data != null) {
      yield put(setViewInspectionInitState({ ...result }));
    }

    yield put(setLoading(false));
  });
};

const deleteInspectonsByTemplateIdSaga = function* (): any {
  yield takeEvery(
    DELETEVIEWINSPECTIONSTEMPLATE,
    function* (action: AnyAction): any {
      const state: DeleteTemplateSetParameterType = yield select(
        (s: RootState) => s.viewInspectionPageReducer
      );

      // set page loading on
      yield put(setLoading(true));

      const deleteParameter: DeleteTemplateParameterType = action.payload;
      // get data from backend
      try {
        let result: ActionResponseType = yield call(() =>
          deleteInspectonsByTemplateIdAPi(deleteParameter)
        );
        if (result.IsSuccess) {
          yield put(
            openPopup({
              Open: true,
              BodyText: "Inspection removed successfully",
              HeaderText: "Success",
              PopupType: EnumPopupType.SuccessPopup,
            } as PopupProps)
          );
          yield put(setDeletedSuuccessfully(true));
        } else {
          yield put(
            openPopup({
              Open: true,
              BodyText: "An error occurred removing inspecton template",
              HeaderText: "Error",
              PopupType: EnumPopupType.ErrorPopup,
            } as PopupProps)
          );
        }
      } catch (error) {
        yield put(
          openPopup({
            Open: true,
            BodyText: "An error occurred removing inspecton template",
            HeaderText: "Error",
            PopupType: EnumPopupType.ErrorPopup,
          } as PopupProps)
        );
      }
      // set page loading off
      yield put(setLoading(false));
    }
  );
};

const viewInspectionPageSaga = function* () {
  yield all([fetchViewInspectionsSaga(), deleteInspectonsByTemplateIdSaga()]);
};

export default viewInspectionPageSaga;
